import { render, staticRenderFns } from "./NoBindEmail.vue?vue&type=template&id=5bb8e87a&scoped=true&"
import script from "./NoBindEmail.vue?vue&type=script&lang=js&"
export * from "./NoBindEmail.vue?vue&type=script&lang=js&"
import style0 from "./NoBindEmail.vue?vue&type=style&index=0&id=5bb8e87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8e87a",
  null
  
)

export default component.exports